import { useEffect, useState } from 'react';
import { Box, BoxProps, CircularProgress, CircularProgressProps, Stack, styled, Typography } from '@mui/material';
import Fade from '@mui/material/Fade';

const StyledLoader = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',

  '&.absolute': {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

export interface LoaderProps extends BoxProps {
  absolute?: boolean;
  size?: CircularProgressProps['size'];
  loadingSentences?: string[];
}

export function Loader({ absolute = false, size, loadingSentences, ...rest }: LoaderProps) {
  return (
    <StyledLoader className={absolute ? 'absolute' : ''}>
      <Box {...rest}>
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
          <div>
            <CircularProgress size={size} />
          </div>
          {loadingSentences && <LoadingSentences sentences={loadingSentences} />}
        </Stack>
      </Box>
    </StyledLoader>
  );
}

const useCycleSentences = (sentences: string[], delay: number) => {
  const [index, setIndex] = useState(0);
  const [inProp, setInProp] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setInProp(false);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % sentences.length);
        setInProp(true);
      }, 500);
    }, delay);
    return () => {
      clearInterval(timer);
    };
  }, [delay, sentences]);

  return { sentence: sentences[index], inProp };
};

function LoadingSentences({ sentences }: { sentences: string[] }) {
  const { sentence, inProp } = useCycleSentences(sentences, 5000);

  return (
    <Fade in={inProp}>
      <Typography variant="body1">{sentence}</Typography>
    </Fade>
  );
}
